import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(_ctx.icon)), {
    class: _normalizeClass(_ctx.iconDomClasses),
    "aria-hidden": "true"
  }, null, 8, ["class"]))
}